import React from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { BiChevronRightCircle } from 'react-icons/bi';
import { Link } from 'react-router-dom';

import { Banner, Content, Index, Icon } from './Tutorial.styled';

interface Props {
  id?: string;
  title: string;
  disabled?: boolean;
  url?: string;
  actionText?: string;
  borderColour?: string;
  borderColourHover?: string;
}

const Tutorial: React.FunctionComponent<Props> = ({
  id,
  title,
  disabled,
  url,
  actionText,
  borderColour,
  borderColourHover,
}: Props) => {
  if (disabled) {
    return (
      <Banner className="disabled" borderColourHover={borderColourHover}>
        <Index borderColour={borderColour}>
          <span>{id}</span>
        </Index>
        <Content>
          <div className="title">{title}</div>
        </Content>
        <Icon className="disabled">
          <span>Disabled</span>
          <AiOutlineCloseCircle />
        </Icon>
      </Banner>
    );
  }

  return (
    <Link to={url as string}>
      <Banner borderColourHover={borderColourHover}>
        <Index borderColour={borderColour}>
          <span>{id}</span>
        </Index>
        <Content>
          <div className="title">{title}</div>
        </Content>
        <Icon>
          <span>{actionText || 'Read More'}</span>
          <BiChevronRightCircle />
        </Icon>
      </Banner>
    </Link>
  );
};

export default Tutorial;
